import React, { useContext, useState, useEffect } from 'react';
import { BookingContext } from '../../context/BookingContext';
import { firestore } from '../../firebase/config';
import './Sidebar.css';

const Sidebar = () => {
  const { bookingData } = useContext(BookingContext);
  const [practitionerInfo, setPractitionerInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  // Charger les informations du praticien sélectionné
  useEffect(() => {
    const fetchPractitionerDetails = async () => {
      if (bookingData.practitioner?.id) {
        setLoading(true);
        try {
          const practitionerDoc = await firestore
            .collection('practitioners')
            .doc(bookingData.practitioner.id)
            .get();

          if (practitionerDoc.exists) {
            const data = practitionerDoc.data();
            setPractitionerInfo(data);
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des informations du praticien:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchPractitionerDetails();
  }, [bookingData.practitioner]);

  // Formatage de la durée pour l'affichage
  const formatDuration = (duration) => {
    if (!duration) return '';
    if (duration === 90) return '1h30';
    if (duration === 60) return '1h';
    if (duration === 45) return '45min';
    return `${duration} min`;
  };

  // Formater l'adresse complète
  const formatAddress = () => {
    if (!practitionerInfo || !practitionerInfo.address) return 'Adresse non disponible';

    const { street, zipCode, city } = practitionerInfo.address;
    let formattedAddress = street || '';

    if (zipCode || city) {
      formattedAddress += `<br />${zipCode} ${city}`.trim();
    }

    return formattedAddress || 'Adresse non disponible';
  };

  return (
    <div className="sidebar">
      <div className="naturopath-info">
        <h3>{bookingData.practitioner?.name || 'Sélectionnez un praticien'}</h3>
        <p>{bookingData.practitioner?.title || ''}</p>
      </div>

      <div className="appointment-summary">
        <h4 className="summary-title">Récapitulatif</h4>

        {bookingData.service && (
          <div className="summary-item">
            <div className="summary-icon">⏱️</div>
            <div className="summary-text">
              <strong>{bookingData.serviceTitle}</strong>
              <div>{formatDuration(bookingData.duration)} - {bookingData.price}€</div>

              {/* Afficher les notes de service si elles existent */}
              {bookingData.notes && (
                <div className="service-notes" style={{
                  marginTop: '8px',
                  padding: '8px',
                  backgroundColor: '#f0f7f3',
                  borderLeft: '3px solid #3a865f',
                  fontSize: 'var(--font-size-small)',
                  whiteSpace: 'pre-line'
                }}>
                  <strong>Informations complémentaires :</strong>
                  <div>{bookingData.notes}</div>
                </div>
              )}
            </div>
          </div>
        )}

        {bookingData.date && (
          <div className="summary-item">
            <div className="summary-icon">📅</div>
            <div className="summary-text">
              {bookingData.formattedDate}
            </div>
          </div>
        )}

        {bookingData.time && (
          <div className="summary-item">
            <div className="summary-icon">🕒</div>
            <div className="summary-text">
              {bookingData.time}
            </div>
          </div>
        )}
      </div>

      <div className="sidebar-info">
        {!loading && practitionerInfo && (
          <>
            <div className="info-block">
              <h5>Adresse du cabinet</h5>
              <p dangerouslySetInnerHTML={{ __html: formatAddress() }}></p>
            </div>

            <div className="info-block">
              <h5>Politique d'annulation</h5>
              <p>{practitionerInfo.cancellationPolicy || "Annulation gratuite jusqu'à 24h avant le rendez-vous. Passé ce délai, la séance sera due."}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Sidebar;